import moment from 'moment'
import { RootState, Module, RegionFormat } from '../types'

export const local: Module<RegionFormat, RootState> = {
  namespaced: true,
  state() {
    return {
      shortDate: '',
      longDate: '',
      shortTime: '',
      longTime: '',
      shortDateTime: '',
      longDateTime: '',
    }
  },
  mutations: {},
  actions: {
    tick1s({ state }) {
      state.shortDate = moment().format('DD-MM-YYYY')
      state.longDate = moment().format('DD MMMM YYYY')
      state.shortTime = moment().format('HH:mm')
      state.longTime = moment().format('HH:mm:ss')
      state.shortDateTime = moment().format('DD-MM-YYYY, HH:mm:ss')
      state.longDateTime = moment().format('DD MMMM YYYY, HH:mm:ss')
    },
  },
  getters: {},
}
